import {BaSeInput} from "@base/react";
import ColoredProgressBar from "../colored-progress-bar";

const InputPercentageGraph = ({
                                name,
                                label,
                                placeholder,
                                subLabel,
                                maxLength = 22,
                                maxValue = 100,
                                background = "",
                                barColor = "",
                                value = "",
                                onExternalChange,
                                ...props
                              }) => {
  const handleInputChange = (e) => {
    let numericValue = parseInt(e.toString().replace(/[^\d]/g, ""), 10)
    if (isNaN(numericValue)) numericValue = 0
    if (numericValue > maxValue) numericValue = maxValue
    numericValue = Math.floor(numericValue)

    if (onExternalChange) {
      onExternalChange(numericValue)
    }

    return numericValue
  }

  return (
    <div className="wrapper-input percentage-graph"
         style={{background: background}}>
      <BaSeInput
        name={name}
        label={label}
        subLabel={subLabel}
        inputStatus
        size="medium"
        width="100%"
        value={value}
        onChange={handleInputChange}
        placeholder={placeholder || "%"}
        inputMode="tel"
        typeInput="tel"
        maxLength={maxLength || 4}
        {...props}
      />
      <ColoredProgressBar barColor="#ffffff" barBackgroundColor={barColor} percentage={value} />
    </div>
  )
}

export default InputPercentageGraph